'use strict';
'use es6';

var _isFunction = require('hs-lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _QueryParamsContainer = require('../../core/globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

var _Logger = require('../../core/lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _SignupApp = require('../../core/SignupApp');

var _SignupApp2 = _interopRequireDefault(_SignupApp);

var _Config = require('./Config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  window.LOG = new _Logger2.default();
  _QueryParamsContainer2.default.hydrate();
  _I18n2.default.langEnabled = true;

  var startApplication = function startApplication(config) {
    var application = new _SignupApp2.default(config);

    if ((0, _isFunction2.default)(config.onStart)) {
      config.onStart(function (maybeDefaultUserValues) {
        application.start(maybeDefaultUserValues);
      });
    } else {
      application.start();
    }
  };

  var cannotStartApplication = function cannotStartApplication(error) {
    LOG.warn('Cannot start Application', {
      fingerprint: ['Bootstrap', 'startApplication'],
      extra: {
        error: error,
        location: window.location
      }
    });
  };

  (0, _Config.getFlowConfig)().then(startApplication).catch(cannotStartApplication);
})();